import React from 'react'
import * as S from './style'
import Svg from '@components/svg'
import { statsdown, statsup, totalusers } from '@assets/icons'
import CardLoader from '@components/skeleton/dashboarcard'
const Analytic = ({ icon, title, value, isUp, loading, onClick }: any) => {
  return (
    <>
      {loading ? (
        <CardLoader />
      ) : (
        <S.StyleAnalyticCard>
          <S.TitleContainer>
            <Svg src={icon || totalusers} styleSvg={S.svgtranslate} />
            <S.StyleAnalyticCardTitle>
              {title || 'Total Users'}
            </S.StyleAnalyticCardTitle>
          </S.TitleContainer>
          <S.StatsContainer>
            <S.StatNumber>{value}</S.StatNumber>
            <S.StartPercentContainer>
              <Svg src={isUp ? statsup : statsdown} styleSvg={S.svgtranslate} />
              <S.StatPercent up={isUp}>{isUp ? '+10%' : '-10%'}</S.StatPercent>
            </S.StartPercentContainer>
          </S.StatsContainer>
          <S.ActionContainer>
            <S.ActionMessage>Users increased in 7 days</S.ActionMessage>
            <S.ActionButton onClick={onClick}>See Details</S.ActionButton>
          </S.ActionContainer>
        </S.StyleAnalyticCard>
      )}
    </>
  )
}

export default Analytic
